import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from "react-helmet";
import {
  Container,
  Row,
  CardGroup,
  Col,
  Media
} from "reactstrap";
import { Link, graphql } from "gatsby";
import { FormattedMessage } from 'react-intl';

import locales from '../constants/locales';
import Layout from '../components/Layout';
import LocalizedLink from '../components/LocalizedLink';
import CardJob from '../components/UIComponents/Cards/CardJob';
import Title from '../components/UIComponents/Title';
import TriDymeIcon from '../media/TriDymeIconV1.svg';
import HeadMeta from '../components/HeadMeta';

const {
  REACT_COMPANY_NAME,
} = process.env;

const metaData = {
  en: {
    title: `TriDyme | Careers`,
    pageTitle: "Careers",
    description: "Join our team of game changers"
  },
  fr: {
    title: `TriDyme | Recrutement`,
    pageTitle: "Recrutement",
    description: "Rejoignez notre équipe pour faire changer les choses"
  }
};

const Career = ({ pageContext: { locale }, data }) => {
  return (
    <Layout locale={locale}>
      <HeadMeta
        locale={locale}
        metaData={metaData}
      />
      <Container className="careerContainer">
        <Row>
          <Title
            icon={TriDymeIcon}
            title={metaData[locale].pageTitle}
            description={metaData[locale].description}
          // itemNumber={data.allMarkdownRemark.totalCount}
          />
        </Row>
        <hr />
        <CardGroup className="cardGroup">
          {data.allMarkdownRemark.edges.map(({ node }) => {
            if (node.frontmatter.status === "published") {
              return (
                <CardJob
                  key={node.id}
                  colnum={12}
                  title={node.frontmatter.title}
                  subtitle={node.frontmatter.date}
                  language={node.frontmatter.language}
                  location={node.frontmatter.location}
                  status={node.frontmatter.status}
                  description={node.frontmatter.description}
                  link={locales[locale].default
                    ? '/' + node.fields.slug
                    : `/${locales[locale].path}` + node.fields.slug}
                  textButtonId="read"
                />
              );
            }
          })}
        </CardGroup>
      </Container>
    </Layout>
  )
}

Career.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired
  }).isRequired
}

export default Career;

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { fileAbsolutePath: {regex : "\/career/"} },
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      totalCount
      edges {
        node {
          frontmatter {
            title
            date(formatString: "DD-MM-YYYY")
            language
            location
            description
            status
          }
          fields {
            slug
          }
          excerpt
        }
      }
    }
  }
`